import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NgControl } from '@angular/forms';
import { noop } from 'rxjs';
import { ValidatorCheck } from '../../utils/validator.check';
import { SelectItem } from 'src/models/general/select.item.model';

@Component({
    selector: 'pim-input-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.sass'],
    standalone: false
})
export class SelectComponent implements ControlValueAccessor, OnInit {

	@Input()
	hideLabel: boolean = false;
	@Input()
	id!: string;
	@Input()
	tabindex!: number;
	@Input()
	label: string = '';
	@Input()
	values!: SelectItem[] | null | undefined;
	@Input()
	multiple: boolean = false;
	@Input()
	emptySelection: boolean = false;
	@Input()
	emptySelectionText: string = '-Bitte wählen-';
	@Input()
	readonly: boolean = false;

	private internalValue: any = '';

	required: boolean = false;

	private onChangeCallback: (_: any) => void = noop;
	control!: UntypedFormControl;

	constructor(private validatorCheck: ValidatorCheck, @Self() public ngControl: NgControl) {
		this.ngControl.valueAccessor = this;
	}

	ngOnInit(): void {
		this.control = this.ngControl.control as UntypedFormControl;
		this.required = this.validatorCheck.isRequired(this.control);
	}

	get value(): any {
		return this.internalValue;
	}

	set value(v: any) {
		if (v !== this.internalValue) {
			this.internalValue = v;
			this.onChangeCallback(v);
		}
	}

	get fullLabel(): string {
		const requiredAstersik = this.required ? ' *' : '';
		if (this.label === undefined) {
			return '';
		}
		return `${this.label}${requiredAstersik}`;
	}

	writeValue(obj: any): void {
		if (this.value !== obj) {
			this.value = obj;
		}
	}

	registerOnChange(fn: any): void {
		this.onChangeCallback = fn;
	}

	registerOnTouched(_: any): void {
		// this.onTouchedCallback = fn;
	}

}
